import {createStrokeSVG} from './TEMPLATE'

// tabler: paint
export const PaintRoller_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -2',
    'M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2',
    'M10 16a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
